import { render, staticRenderFns } from "./zonglanLeft.vue?vue&type=template&id=4ff4b126&scoped=true&"
import script from "./zonglanLeft.vue?vue&type=script&lang=js&"
export * from "./zonglanLeft.vue?vue&type=script&lang=js&"
import style0 from "./zonglanLeft.vue?vue&type=style&index=0&id=4ff4b126&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff4b126",
  null
  
)

export default component.exports